import Keycloak from "keycloak-js";

const keycloak = new Keycloak({
  url: process.env.REACT_APP_KEYCLOAK_URL,
  realm: process.env.REACT_APP_KEYCLOAK_REALM,
  clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID,
});

export const initKeycloak = (onInit, onError) => {
  console.info("Initializing Keycloak...");
  keycloak.init({
    onLoad: "check-sso",
    pkceMethod: "S256",
    silentCheckSsoRedirectUri: window.location.origin + "/silent-check-sso.html",
  })
  .then((authenticated) => {
    if (!authenticated) {
      keycloak.login();
      return;
    }

    localStorage.setItem("jwtToken", keycloak.token);
    onInit(true);

    // Token Refresh
    setInterval(() => {
      if (keycloak.token) {
        keycloak.updateToken(30)
          .then((refreshed) => {
            if (refreshed) localStorage.setItem("jwtToken", keycloak.token);
          })
          .catch(() => keycloak.logout());
      }
    }, 30000);
  })
  .catch((err) => {
    console.error("Keycloak init error:", err);
    onError(err);
  });
};

export default keycloak;
